import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28,8H22.8L21.58,6a2,2,0,0,0-1.71-1H12.13a2,2,0,0,0-1.71,1L9.2,8H7A1,1,0,0,0,5,8H4a2,2,0,0,0-2,2V25a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM16,24a7,7,0,1,1,7-7A7,7,0,0,1,16,24ZM26,14a2,2,0,1,1,2-2A2,2,0,0,1,26,14Z"/><circle cx="16" cy="17" r="5"/>';
export var CameraSVG = function CameraSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CameraSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CameraSVG);